import { useState, useRef } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    
    const Entries = [
        {
            name: "Los Angeles City Hall Model",
            description: "This is a scale rendition of the Los Angeles City Hall located in the Civic Center of Downtown Los Angeles, California. City Hall is the concentration of all public services and government for the City of Los Angeles (Not to be confused with the county). With it being home to the mayor's office, city council chambers, city attorney's office, and so much more. The Art Deco building, constructed in 1928, at the time was the largest building in the Downtown Skyline at a height of 458 feet. It has an observation deck at the top, along with the auxiliary city office building dubbed 'City Hall East' with a much more Modern and Brutalist architecture style. \n\n I made this mod because I have been trying to do a playthrough where I tried to replicate a city with the development patterns of Los Angeles and was disappointed to find the lack of a city hall for my city on the workshop. So I decided to remedy that. I tried to remain as faithful to the original as possible whilst also not compromising on performance and I'm proud of the result. However I did have to leave some aspects out due to the Asset Creation tool having a 16 by 8 grid limit on how large your asset can be. Aspects like the shaded plaza on the southern end of City Hall, the plaza to the south of City Hall East, City Hall South, and the dead, subterranean, Los Angeles Mall to the North of City Hall East. If I get enough support from this mod maybe I'll make those next. Although currently I'm focusing on making LA Union Station and the LA Metro B Line station exteriors from downtown and mid city so stay tuned for those. Also as a tip, this building works best when on flat terrain so make sure you level it out before placing otherwise the streets are gonna be weird.",
            photos: [
                "https://images.steamusercontent.com/ugc/10993422387599933440/D3A1566F51719461F5E8CB5BD4E627FD9FD460A6/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/16706541581484447214/3C6EA1ECE57DDB01406EE872B4CE24913DDD8C9D/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/13089087737421124899/CD53344CA22D1833E0C3470709D1934D51E40B3F/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
                "https://images.steamusercontent.com/ugc/18339349723961579640/6D05E55ADC2CA07E0F27FA0211585F444E01947F/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=truee"
            ]
        },
        {
            name: "Civic Center/Grand Park Station LA Metro Station",
            description: "Girl I have done it again constantly raising the bar for you all and doing it flawlessly. You'd like to say you're surprised but you know who I am. Once again, back with another LA Asset. \n\n This month I give you a scale recreation of the MOS-1 Stations on the Los Angeles Metro Rail B and D Lines. Opening in 1993 as part of the Red Line Project. MOS-1, or Minimum Operating Segment 1, was the first five of what by the year 2000 would be thirteen new heavy rail subway stations running from the heart of Downtown Los Angeles, to Hollywood, and the San Fernando Valley. This first segment runs from Union Station in Chinatown, to the Civic Center/Grand Park Station by City Hall, to Pershing Square at 5th and Hill, then 7th Street/Metro Center at 7th and Figueroa, and terminating at Westlake/MacArthur Park. These stations were some of the first in the Metro Rail system. Marking the beginnings of the mass transit renaissance that can still be felt in Los Angeles. \n\n Each minimum operating segment of the red line has its own unique quirks in their architecture and MOS-1 is no exception. Stations on this operating segment, with the Exception of Union Station and 7th Street/Metro Center, all have a distinct ovular canopy supported by 3 steel beams that covers the escalators into the station. With stainless steel fittings within the canopy, covered by a teal tinted glass roof. Additionally these stations all have a marble U shape around the edge of the opening that leads you underground to the station. With a circular stainless steel beam aligning with it. \n\n For this project however, my main inspiration was the Civic Center/Grand Park station located in the middle of the Gloria Molina Grand Park and a short walk away from City Hall. As the name implies this is located in the Center of Government for LA County. A frequent spot for banal mundanities like accessing government services, court appearances, and local government work it also tends to be a hotspot for protests, rallies, and civic action. With the area being a large concentration of anti-ICE protests in June of 2025. However, the station is also as the name once again suggests, in a park. Making it an excellent destination to travel to for a pleasant picnic when the area isn't be rocked by Civil Unrest and Protest. \n\n I did take some creative liberties in order to make it work better with the game. This station only has one entrance which isn't accurate for most MOS-1 stations. With the exception of Westlake/Macarthur Park which had it's second entrance closed off for security reasons in 2020.,all MOS-1 stations tend to have two entrances. Additionally some of the plants and benches aren't accurate because I just didn't wanna make new ones so I used the vanilla ones.",
            photos: [
                "https://images.steamusercontent.com/ugc/10561041135914445921/52532D4D7C2054088744C41FDCE499BA70D84BD3/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/14654944489553042455/AFA5B1B2B5300F593190B8C52597E6DA400650C7/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/17214010324497362434/7EC96E3C2873810092FAA20628BFBB9C17239627/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/9781363640375046008/6D82BEF0964D31FCBA26C5F618542509FE6627E5/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true"
            ]
        },
        {
            name: "gm_black_creek_ave",
            description: "Blah blah blah, test",
            photos: [
                "https://images.steamusercontent.com/ugc/2070013166207877333/76E18CF9B17A77546495810D4410D2EFA3F2CFC0/?imw=268&imh=268&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/17501991701299868889/493133F771BB8848CE8FF3D88F6AC796DB3510F1/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/10445627443706389814/6DB9815B4BAE040DC57E6E81A1309A202016719E/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/11180726035140598392/F4E5897C3415F48CCCA180642A60531DE7505D5F/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/12705470073279363072/A6999C6FAB9ADC0EAFD5B8F3CC133FA605AB79EF/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
                "https://images.steamusercontent.com/ugc/15491564473415398354/8A06FC6ED995C1B431F64CB2F493464D6C689096/?imw=637&imh=358&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=true",
            ]
        },
        {
            name: "Untethered",
            description: "Blah blah blah, test",
            photos: [
                "/images/works/EnvironmentArt/ACTIILevelI1.png",
                "/images/works/EnvironmentArt/ACTIILevelI2.png",
                "/images/works/EnvironmentArt/ACTIILevelI3.png",
            ]
        }
        
    ]
    
    const [selectedEntry, setSelectedEntry] = useState(Entries[0]);
    const [photoIndex, setPhotoIndex] = useState(0);
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
        navigate(dir);
    };
    
    const handleEntryClick = (entry) => {
      setSelectedEntry(entry);
      setPhotoIndex(0);
    };
    
    const listItems = Entries.map((Entry, index) =>
                                  <div key={index}>
                                    <MenuListItem style={{ whiteSpace: 'normal', height: 'auto' }} onClick={() => setSelectedEntry(Entry)}>
                                        {Entry.name}
                                    </MenuListItem>
                                  <Separator />
                                  </div>
                                  );
    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "800px"}}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Environment and Level Design</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/Backpage')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
            <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, display: 'flex', flexDirection: "column" }}>
            <div style={{ 
                    width: '100%', 
                    flex: 5,
                    background: 'black', 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                    }}>
                <img
                    src={selectedEntry.photos[photoIndex]}
                    alt={selectedEntry.name}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                    }}
                />
                </div>
            
              
              <div style={{ display: 'flex', flexDirection: 'row', flex: 3, overflow: 'hidden' }}>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <MenuList style={{ display: 'flex', flexDirection: 'column' }}>
                    {listItems}
                  </MenuList>
                </ScrollView>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <div style={{ padding: '1rem' }}>
                  {selectedEntry.description.split('\n\n').map((para, i) => (
                    <p key={i}>{para}</p>
                    ))}
                  </div>
                </ScrollView>
              </div>
                
              <div style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
              {selectedEntry.photos.length > 1 ?
                    <MenuList inline>
                        
                    <MenuListItem onClick={() => setPhotoIndex(i => Math.max(i - 1, 0))}>Previous</MenuListItem>
                    <MenuListItem onClick={() => setPhotoIndex(i => Math.min(i + 1, selectedEntry.photos.length - 1))}>Next</MenuListItem>
                      </MenuList> : <div></div>
                }
                <Button 
                  className='big-button'
                  style={{ width: '100%', height: '100%', flex: 1, display: "none"}} 
                  fstyle={{ height: '100%', width: '100%', fontSize: '2rem !important' }} 
                  onClick={() => linkOut(selectedEntry.link)}
                >
                  Check this out on Roblox
                </Button>
              </div>
              </Frame>

            
            
            
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
